export const accordionList = [
  {
    id: "1",
    header: "What is impact testing?",
    content: (
      <p>
        Impact testing is a controlled process that simulates real-world forces
        such as hail, debris, or other impacts on building materials to assess
        how they respond. This helps evaluate durability, performance, and
        potential product failure under stress.
      </p>
    ),
  },
  {
    id: "2",
    header: "What is the cost for a test?",
    content: <p>Testing is $500 and includes shipping</p>,
  },
  {
    id: "3",
    header: "How do I send a sample for testing?",
    content: (
      <p>
        After completing your order, you will receive an email with a prepaid
        shipping label and packing instructions. Please email Unit 5 if you do
        not receive the email.
      </p>
    ),
  },
  {
    id: "4",
    header: "What is included in the report?",
    content: (
      <p>
        Each report includes material type, manufacturer, and brand (if
        applicable), manufacturer’s warranty information, as well as material
        sample conditions before and after testing. The report documents any
        observed changes in material integrity as a result of impact tests.
      </p>
    ),
  },
  {
    id: "5",
    header: "How are tests performed?",
    content: (
      <p>
        All testing is conducted using standardized, repeatable procedures with
        calibrated equipment. All tests are documented, including photographs.
        Our methods simulate real-world impact scenarios, ensuring accuracy and
        precision.
      </p>
    ),
  },
  {
    id: "6",
    header: "Do I need to send physical samples?",
    content: (
      <p>
        Yes. All impact testing requires physical material samples. The material
        sample must be of sufficient size and condition for the ordered test(s).
        After your order is received, we will email detailed instructions for
        shipping the material sample to our facility.
      </p>
    ),
  },
];
